import React from 'react';
import Modal from '../../components/modal/modal';
import Textarea from "../UI/Textarea/Textarea";
import Select from "../UI/Select/Select";
import Form from "../forms/forms";
import {apiHost} from "../../common/config";
import _ from 'lodash';

class FeedbackModal extends Form {

    requestUrl = `${apiHost}/feedback/send`;

    // Кнопка «Отправить» и так неактивна при пустом сообщении, но правила
    // нужны для подсветки поля и внятной ошибки, если пустоту не поймала
    // кнопка (например, сообщение из одних пробелов).
    validationRules = {
        message: {require: true, title: 'Сообщение'}
    };

    constructor(props) {
        super(props);

        this.state = {
            // Сохраняем errors/responseError/status из Form: раньше state
            // перезаписывался целиком и подсветка ошибок не работала.
            ...this.state,
            feedbackModalOpen: false,
            filledMessage: '',
            submitButtonFunc: false,
            subjects: [
                {value: 'support', label: 'Техническая поддержка: вопросы по работе сайта'},
                {value: 'academySupport', label: 'Essilor  Академия: вопросы по продуктам Essilor'}
            ],
            selectedSubject: {value: 'support', label: 'Техническая поддержка: вопросы по работе сайта'},
            showForm: true,
            showButtonClose: true,
            emailSent: true
        };
    }

    showModal(event) {
        event.preventDefault();
        this.setState({feedbackModalOpen: true})
    }

    closeModal = () => {
        this.setState({
            feedbackModalOpen: false,
            showForm: true,
            showButtonClose: true,
            emailSent: true,
            errors: {},
            selectedSubject: {value: 'support', label: 'Техническая поддержка: вопросы по работе сайта'}
        })
    };

    checkSendButton(event) {
        this.removeError(event);
        switch (event.target.name) {
            case 'subject':
                this.setState({filledSubject: event.target.value}, this.fillSubmitButtonFunc);
                break;
            case 'message':
                this.setState({filledMessage: event.target.value}, this.fillSubmitButtonFunc);
                break;
            default:
                break;
        }
    }

    submitFunc = () => {
        const formData = new FormData();
        const subject = this.state.selectedSubject.value;

        formData.append('subjectCode', subject);
        formData.append('message', this.state.filledMessage.trim());

        this.validateForm(formData);
    }

    submitRequestCalllback = (res) => {
        // Бэкенд (Feedback::sendFeedback) сообщает в emailSent, ушло ли письмо
        // в поддержку. Раньше результат отправки не проверялся и портал всегда
        // рапортовал об успехе.
        //
        // Проверка именно на === false: старые ответы поля не содержат, и без
        // этого фронт, выкаченный раньше бэка, показывал бы ошибку на ровном
        // месте.
        const emailSent = !res || !res.data || res.data.emailSent !== false;

        this.setState({
            showForm: false,
            submitButtonFunc: false,
            showButtonClose: false,
            emailSent
        });
    }

    /**
     * Текст, который заменяет форму после отправки.
     *
     * Вынесен из render(), потому что модалка есть в двух вариантах
     * (feedback-modal / feedback-modal-ext) со своими render'ами — иначе текст
     * пришлось бы держать в двух копиях и следить, чтобы они не разъезжались.
     */
    renderConfirmation() {
        const {emailSent, selectedSubject} = this.state;

        if (!emailSent) {
            return <p>Обращение принято — мы его получили. Из-за технической ошибки ответ может занять больше времени, чем обычно.</p>;
        }

        return selectedSubject.value == 'support'
            ? <p>Ответ на ваше обращение придет на вашу электронную почту в течение 1 рабочего дня.</p>
            : <p>Ответ на ваше обращение придет на вашу электронную почту в течение 2 рабочих дней.</p>;
    }


    fillSubmitButtonFunc() {
        if (this.state.filledMessage.trim() !== '') {
            this.setState({submitButtonFunc: this.submitFunc})
        } else {
            this.setState({submitButtonFunc: false})
        }
    }

    handleChangeSubject(selectedOption) {
        this.setState({selectedSubject: selectedOption});
    }

    render() {
        const {showForm} = this.state;

        return (
            <>
                <button className="Menu__feedback flex"
                        onClick={(event) => this.showModal(event)}>
                    <span>Задать вопрос</span>
                    <i className="text-2xl ml-2 icon-question-feedback opacity-50"/></button>

                <Modal isOpen={this.state.feedbackModalOpen} onClose={this.closeModal} title="Обратная связь"
                       onSubmit={this.state.submitButtonFunc} hideCloseButton={!this.state.showButtonClose}>
                    { showForm ?
                        <>
                            <Select
                                name="subject"
                                label="Тема обращения"
                                options={this.state.subjects}
                                value={this.state.selectedSubject}
                                className="w-full"
                                onChange={(selectedOption) => this.handleChangeSubject(selectedOption)}
                            />
                            <Textarea
                                placeholder="Сообщение"
                                rows="5"
                                name="message"
                                id="feedbackMessage"
                                onInput={(e) => this.checkSendButton(e)}
                                errors={this.state.errors}
                            />
                        </>
                        : this.renderConfirmation()
                    }
                </Modal>
            </>
        );
    }
}

export default FeedbackModal;
